module.exports = __webpack_public_path__ + "static/media/clock-history 1.fbcb5907.svg";